import {SelectBody} from "./Dropdown/SelectBody";

const uniqueSelects: Array<HTMLInputElement> = Array.from(document.querySelectorAll('.js-wl-checkbox-unique-select'));
uniqueSelects.forEach(it => new SelectBody(it, false, true, () => []))
